import { useCallback, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { PageRoutes } from "../../../constants/routes";
import { useNavigation } from "../../../hooks/useNavigation";

export const useEmailSendComplete = () => {
  const { navigateToPage } = useNavigation();
  const { state } = useLocation();
  const { password, email, token } = state ?? {};

  useEffect(() => {
    if (!email || !token) return navigateToPage(PageRoutes.LOGIN);
  }, [email, token, navigateToPage]);

  const maskedEmail = useMemo(() => {
    if (!email) return "";
    const [localPart, domain] = email.split("@");
    if (!domain) return email;
    const maskedLocal =
      localPart.length > 2
        ? `${localPart.slice(0, 2)}${"*".repeat(localPart.length - 2)}`
        : "*".repeat(localPart.length);
    return `${maskedLocal}@${domain}`;
  }, [email]);

  const handleEmailSendComplete = useCallback(() => {
    navigateToPage(PageRoutes.EMAIL_REGISTRATION, false, {
      password,
      email,
      token,
    });
  }, [email, navigateToPage, password, token]);

  return { maskedEmail, handleEmailSendComplete };
};
